import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
import CLOSE_ICON from '../../assets/images/icons/close-btn-2.png'
import KYC_COVER from '../../assets/images/cover/kyc-popup.png'
import { Base_API } from '../../_actions/matcher'

export const ALERT = {
    customAlert,
    AlertUpdateKYC
}

function customAlert(title, body, textBtn, callback){
    MySwal.fire({
        html: 
        <div className="swal-cfpm">
            <div className="top">
                <div
                    onClick={() => MySwal.close()}
                >
                    <img
                        src={CLOSE_ICON}
                    />
                </div>
            </div>

            <div className="mid">
                <h2 className="title">
                    {title}
                </h2>
                <p className="desc">
                    {body}    
                </p>
            </div>

            <div className={`bottom`}>
                <button
                    type="button"
                    onClick={() => MySwal.close()}
                >
                    {textBtn}
                </button>
            </div>
        </div>
        ,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false
    })
    .then(() => {
        if(!!callback) callback();
    });
}

function AlertUpdateKYC() {
    const goToKYC = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/overview-1`;
    }

    MySwal.fire({
        html: 
        <div className="swal-cfpm-kyc">
            <div className="top">
                <img onClick={() => MySwal.close()} src={CLOSE_ICON} />
            </div>

            <div className="cover">
                <img src={KYC_COVER} />
            </div>

            <div className="mid">
                <h2 className="title">คุณยังไม่ได้อัปเดตข้อมูล</h2>
                <p className="desc">
                    โปรดอัปเดตข้อมูลยืนยันตัวตนของคุณตอนนี้ หรือติดต่อเจ้าหน้าที่ เพื่อใช้งานแอปพลิเคชั่น
                </p>
            </div>

            <div className={`bottom`}>
                <button type="button" onClick={goToKYC}>
                    อัปเดตตอนนี้
                </button>
                <button type="button" onClick={() => MySwal.close()}>
                    ข้ามไปก่อน
                </button>
            </div>
        </div>
        ,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false
    })
}